import React from 'react'

import { Box, Text, Space, FontFamily, Checkbox, Color } from '@gousto-internal/citrus-react'
import { useFormikContext } from 'formik'
import { useDispatch } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { useFocusVisibleOutline } from 'routes/Checkout/Components/useFocusVisibleOutline'

import { PostcodeAddressFields } from '../../PostcodeAddressFields'
import { checkoutPaymentConfig } from '../config'
import type { FormFields } from '../useAddressDetailsForm'

export const CheckoutBillingAddress = () => {
  const { values, setFieldValue } = useFormikContext<FormFields>()
  const {
    checkoutBillingAddress: { header, sameBillingAddressCheckbox },
  } = checkoutPaymentConfig

  const {
    outline: isBillingAddressCheckboxFocused,
    handleFocus,
    handleBlur,
  } = useFocusVisibleOutline()

  const dispatch = useDispatch()

  const handleBillingAddressChange = () => {
    setFieldValue('isBillingAddressDifferent', !values.isBillingAddressDifferent)

    dispatch({
      type: actionTypes.PAYMENT_BILLING_ADDRESS_DIFFERENT,
      isBillingAddressDifferent: !values.isBillingAddressDifferent,
    })
  }

  return (
    <>
      <Box>
        <Box paddingV={2}>
          <Text fontFamily={FontFamily.Bold} size={2}>
            {header}
          </Text>
        </Box>
        <Checkbox
          id="checkoutBillingAddress"
          color={Color.Secondary_400}
          checked={!values.isBillingAddressDifferent}
          data-testid="checkoutBillingAddressToggle"
          onChange={handleBillingAddressChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          outline={isBillingAddressCheckboxFocused}
        >
          {sameBillingAddressCheckbox}
        </Checkbox>
        {values.isBillingAddressDifferent && (
          <>
            <Space size={3} direction="vertical" />
            <PostcodeAddressFields />
          </>
        )}
      </Box>
      <Space size={4} direction="vertical" />
    </>
  )
}
